<template>
 <div>
      <form :class="['search-vacancies borderR5']">
        <span class="h3-span filter__title">{{ lng.refine_by }}</span>
        <div class="filter__mobile">
          <VesselsType></VesselsType>
          <Rank></Rank>
          <Salary></Salary>
          <Buttons v-if="isUser"></Buttons>
        </div>
    </form>
 </div>

 </template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VesselsType from './VesselsType.vue'
import Salary from './Salary.vue'
import Duration from './Duration.vue'
import EnglishLevel from './EnglishLevel.vue'
import Countries from './Countries.vue'
import Buttons from './Buttons.vue'
import Rank from './Rank.vue'

export default {

   components: {
        VesselsType, Buttons, Rank
   },

   computed: {
            ...mapGetters(['lng']),
            isUser(){
                return typeof uid !== "undefined";
            }
   },
   methods: {

   }

}
</script>




// WEBPACK FOOTER //
// Filters.vue?0620d53a